// in src/MyLayout.js
import React from "react";
import { Layout, useRefresh } from "react-admin";
import { TetherAppBar } from "../components/TetherAppBar";
import { useEffect, useRef } from "react";
import { useLocation } from "react-router-dom";

// Define the paths where background auto-refresh is allowed
const ALLOWED_ROUTES = ["/Assets", "/Violations", "/aggregate", "/track"];

export const ResumeReloadHandler = () => {
    const refresh = useRefresh();
    const { pathname } = useLocation();
    const lastRefreshTime = useRef(0);

    useEffect(() => {
        const handleResume = () => {
            if (document.visibilityState === "visible") {
                // 1. Check if the current route matches your allowed routes list
                const isRouteAllowed = ALLOWED_ROUTES.some(route => pathname === route || pathname.startsWith(`${route}/`));

                if (!isRouteAllowed) return;

                const now = Date.now();
                // Prevent duplicate execution within 3 seconds
                if (now - lastRefreshTime.current > 3000) {
                    lastRefreshTime.current = now;
                    refresh();
                }
            }
        };

        document.addEventListener("visibilitychange", handleResume);
        window.addEventListener("focus", handleResume);

        return () => {
            document.removeEventListener("visibilitychange", handleResume);
            window.removeEventListener("focus", handleResume);
        };
    }, [refresh, pathname]); // 2. Add pathname to dependency array

    return null;
};

const AdminLayout = props => (
    <>
        <ResumeReloadHandler />
        <Layout {...props} appBar={TetherAppBar} />;
    </>
);
//  menu={VehicleMenu}
export default AdminLayout;
